import React, { useRef, useEffect } from 'react';

interface VerificationInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete: (value: string) => void;
  disabled?: boolean;
}

export const VerificationInput: React.FC<VerificationInputProps> = ({
  value,
  onChange,
  onComplete,
  disabled = false
}) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    // 自动聚焦第一个输入框
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleInput = (index: number, inputValue: string) => {
    const newValue = value.split('');
    newValue[index] = inputValue.slice(-1);
    const finalValue = newValue.join('');
    onChange(finalValue);

    // 自动跳转到下一个输入框
    if (inputValue && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }

    // 如果所有数字都已输入，触发完成事件
    if (finalValue.length === 6) {
      onComplete(finalValue);
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      // 当前输入框为空且按下删除键时，跳转到上一个输入框
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, 6);
    const numbers = pastedData.replace(/[^0-9]/g, '');
    
    if (numbers) {
      onChange(numbers.padEnd(6, ''));
      // 聚焦到最后一个有值的输入框的下一个
      const focusIndex = Math.min(numbers.length, 5);
      inputRefs.current[focusIndex]?.focus();
    }
  };

  return (
    <div className="grid grid-cols-6 gap-2">
      {Array(6).fill(0).map((_, index) => (
        <input
          key={index}
          ref={el => inputRefs.current[index] = el}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={1}
          value={value[index] || ''}
          disabled={disabled}
          className="w-full h-12 text-center text-xl font-semibold 
                   bg-white/10 border border-white/10 rounded-lg
                   text-white placeholder-gray-400 
                   focus:outline-none focus:border-indigo-500
                   transition-all duration-300
                   disabled:opacity-50"
          onChange={e => handleInput(index, e.target.value)}
          onKeyDown={e => handleKeyDown(index, e)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
}; 